import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestData({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'vazaoposto', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteData({ payload }) {
  try {
    const { id, params } = payload;

    yield call(api.delete, `vazaoposto/${id}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.post, 'vazaoposto', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/PostoVazao.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { id } = payload;

    const { data } = yield call(api.get, `vazaoposto/${id}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { data, params } = payload;

    yield call(api.put, 'vazaoposto', data);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/PostoVazao.swf');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'vazaoposto', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@vazaoPosto/DATA_IN_REQUEST', requestData),
  takeLatest('@vazaoPosto/DELETE_DATA', deleteData),
  takeLatest('@vazaoPosto/SUCCESS_REMOVE', requestData),
  takeLatest('@vazaoPosto/STORE_DATA', store),
  takeLatest('@vazaoPosto/FIND_DATA', find),
  takeLatest('@vazaoPosto/UPDATE_DATA', update),
  takeLatest('@vazaoPosto/RECORD_FILTERING', applyedFilters),
]);
